import { Col, Container, Row } from "reactstrap";

const Benefit = () => {

  const listBenefits = [
    { title:"Langsung Siap Kerja", body:"Skill kerja nyata, bukan cuma teori — bikin CV kamu lebih menjual di mata recruiter!." },
    { title:"Pengalaman Internasional", body:"Belajar + hidup di Australia, tambah jaringan global, pengalaman budaya, dan gaya hidup baru!." },
    { title:"Jalur ke Universitas", body:"Beberapa kursus bisa jadi pathway ke universitas di Australia — artinya, bisa lanjut ke gelar yang lebih tinggi!." },
    { title:"Kerja Sambil Studi", body:"Dengan visa pelajar, biasanya kamu bisa kerja paruh waktu untuk bantu biaya hidup. Itu pengalaman + income juga! (cek syarat visa ya)." },
  ]

  return (
    <section className="section benefit-wrapper" id="benefit">
      <Container>
        <Row>
          <Col xs='12' md='7' className="benefit-items">
            <h1><b>Benefit Kuliah di TAFE International Western Australia (TIWA)</b></h1>
              <ol>
                {listBenefits.map((item, id) => (
                  <li key={id}>
                    {item.title}
                    <p className="fw-normal">{item.body}</p>
                  </li>
                ))}
              </ol>
          </Col>    
          <Col xs='12' md='5' className='benefit-bg'>
            <img 
              src="assets/images/benefit-bg.webp" 
              alt="student-searching-benefits-study-at-melbourne-poly" 
              className="img-fluid"
            />
          </Col>        
        </Row>
      </Container>
    </section>
  );
};

export default Benefit;